import Masonry from 'masonry-layout';

const gallery = document.querySelector('.media-gallery');

if (gallery) {
  const galleryContainer = gallery.querySelector('.grid')
  const masonry = new Masonry(galleryContainer, {
    itemSelector: '.grid-item',
    columnWidth: '.grid-sizer',
    percentPosition: true
  });
}
